import React, { Component } from "react";
import PropTypes from "prop-types";

class BaseInputRadio extends Component {
	static propTypes = {
		checked: PropTypes.bool.isRequired,
		label: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
		id: PropTypes.string.isRequired,
		value: PropTypes.string.isRequired,
		onChange: PropTypes.func.isRequired
	};

	onChange = () => {
		const { onChange, value} = this.props;
        console.log(value)
		onChange(value);
	};

	render() {
		const { onChange, props: { checked, label, value, name, id } } = this;

		return (
            <div className="form-group">
                <input
                    type="radio"
                    className="radio-wrapper--radio"
                    name={name}
                    id={id}
                    value={value}
                    checked={checked}
                    onChange={onChange}
                />
                <label htmlFor={id} className="no-margin">
                    {label}
                </label>
            </div>
		);
	}
}

export default BaseInputRadio;
